import { useNavigate } from 'react-router-dom';
import { Play } from 'lucide-react';
import './demo.css';

const demos = [
  {
    id: 'ciso',
    path: '/demo/ciso',
    title: 'For CISOs',
    desc: 'Operational urgency',
    duration: '~60 seconds',
    color: '#F59E0B',
    cardClass: 'demo-card-amber',
  },
  {
    id: 'investor',
    path: '/demo/investor',
    title: 'For Investors',
    desc: 'Category creation',
    duration: '~60 seconds',
    color: '#6366F1',
    cardClass: 'demo-card-indigo',
  },
  {
    id: 'linkedin',
    path: '/demo/linkedin',
    title: 'For LinkedIn',
    desc: 'Silent autoplay',
    duration: '~45 seconds',
    color: '#10B981',
    cardClass: 'demo-card-emerald',
  },
  {
    id: 'temporal',
    path: '/demo/temporal',
    title: 'Temporal Proof',
    desc: 'See governance change over time',
    duration: '~30 seconds',
    color: '#6366F1',
    cardClass: 'demo-card-indigo',
  },
];

export default function DemoSelector() {
  const nav = useNavigate();

  return (
    <div className="demo-selector-root" data-testid="demo-selector">
      {/* Logo */}
      <div style={{ position: 'absolute', top: 32, left: 40 }}>
        <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 16, fontWeight: 700, color: '#F8FAFC', letterSpacing: 2 }}>
          APEX
        </span>
      </div>

      {/* Center content */}
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' }}>
        <h1 style={{ fontFamily: "'Cabinet Grotesk', 'Inter', sans-serif", fontSize: 32, fontWeight: 700, color: '#F8FAFC', letterSpacing: 2, textAlign: 'center', marginBottom: 8 }}>
          APEX TRUST — TEMPORAL AI GOVERNANCE · PROOF INFRASTRUCTURE
        </h1>
        <p style={{ fontSize: 16, color: '#64748B', marginBottom: 56 }}>
          Select your demo
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24, maxWidth: 1100, width: '100%' }}>
          {demos.map((d) => (
            <div
              key={d.id}
              className={`demo-card ${d.cardClass}`}
              onClick={() => nav(d.path)}
              data-testid={`demo-card-${d.id}`}
            >
              <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F8FAFC', marginBottom: 8 }}>
                {d.title}
              </h2>
              <p style={{ fontSize: 14, color: '#94A3B8', marginBottom: 4 }}>{d.desc}</p>
              <p style={{ fontSize: 12, color: '#64748B' }}>{d.duration}</p>
              <div
                className="demo-play-btn"
                style={{ background: d.color + '15', border: `2px solid ${d.color}` }}
              >
                <Play size={22} style={{ color: d.color, marginLeft: 2 }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
